import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';

class PosOrderPage extends React.Component {
  _isMounted = true;
  comp = StorageService.getSession('selected_org');
  constructor() {
    super();
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      storeList: [],
    };
  }

  componentDidMount() {
    this.getUserStore();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getUserStore = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      ProfileID: user.userId,
    };

    axios
      .post(url + ':3000/v1/user/getContentAccess', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        StorageService.setSession('user_access', result.data);
        this.getStoreList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getStoreList() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const access = StorageService.getSession('user_access');
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          let storeList = [];
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (
                  i.role == 'Admin' ||
                  i.role == 'Supervisor' ||
                  i.role == 'Financial' ||
                  i.role == 'Manager' ||
                  i.role == 'Superuser'
                ) {
                  storeList.push(j);
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  store = (id, name) => {
    this.props.history.push({
      pathname: '/posorder/store/' + id,
      state: { name: name },
    });
  };

  render() {
    let { Role } = this.state;
    return (
      <Page
        className="PosOrderPage"
        title="Store"
        breadcrumbs={[{ name: 'Store', active: true, path: '/posorder' }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        {(Role === 'Superuser' ||
          Role === 'Admin' ||
          Role === 'Manager' ||
          Role === 'Supervisor' ||
          Role === 'Financial' ||
          Role === 'User') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Table responsive hover className="ps-table tb-col-7">
                    <thead>
                      <tr>
                        <th>Store Code</th>
                        <th>Name</th>
                        <th>Location</th>
                        <th>Remarks</th>
                        <th>Timezone</th>
                        <th>Report Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.storeList.length < 1 && (
                        <tr>
                          <td colSpan="7">
                            <div className="ps-empty-data">
                              <div className="empty-content">
                                <h4>No data to show</h4>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}

                      {this.state.storeList.length > 0 &&
                        this.state.storeList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.store_code}</td>
                              <td>{item.name}</td>
                              <td>{item.location}</td>
                              <td>{item.remarks}</td>
                              <td>{item.timezone}</td>
                              <td>{item.report_time}</td>
                              <td>
                                <div className="ps-action-button">
                                  <Button
                                    className="theme-button theme-button-secondary"
                                    onClick={() =>
                                      this.store(item.store_id, item.name)
                                    }
                                  >
                                    View
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    );
  }
}

export default PosOrderPage;
